// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/@pmmmwh/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?protocol=wss&hostname=sandbox.onspace.com.br&port=443&pathname=%2Fws&logging=none&overlay=%7B%22errors%22%3Atrue%2C%22warnings%22%3Afalse%7D&reconnect=10&hot=true&live-reload=true");
__webpack_require__("./node_modules/webpack/hot/dev-server.js");
var __webpack_exports__ = __webpack_require__("./src/index.js");
